import { render, staticRenderFns } from "./contractData.vue?vue&type=template&id=08835a69&scoped=true"
import script from "./contractData.vue?vue&type=script&lang=js"
export * from "./contractData.vue?vue&type=script&lang=js"
import style0 from "./contractData.vue?vue&type=style&index=0&id=08835a69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08835a69",
  null
  
)

export default component.exports